import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly urlGetTranslate = `${environment.baseURL}/translate`;

  constructor(
    private readonly http: HttpClient,
    private translate: TranslateService,
  ) { }

  public getAll(params: any) {
    return this.http.get<any>(this.urlGetTranslate, { params } )
      .pipe(map(v => v.data), tap((res) => {
        switch (params.language) {
          case 'uk':
            this.translate.setTranslation('ua', res, true);
            break;
          case 'en':
            this.translate.setTranslation('en', res, true);
            break;
        }
        this.translate.setDefaultLang('ua');
        this.translate.use(localStorage.getItem('language') ?? 'ua');
      }));
  }
}
